module.exports = __webpack_public_path__ + "img/yellow@2x.d90a88a3.png";